<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-one-short-history-of-meditation-and-practice">
<h1>Chapter One<br/> Short History of Meditation and Practice</h1>
<p style="text-align: center;"><em>“I think, therefore I am.”</em></p>
<p style="text-align: center;">–René Descartes, French Philosopher, Mathematician and Scientist</p><br/>
<p style="text-indent:00em;">According to my research online, and from reading the information shared on Wikipedia.org, it would appear that the Indian subcontinent is the first to depict the practice of sitting in a meditative state. Wall art dating back from 3,500 to 5,000 BCE depicts figures with eyes shut and legs crossed over. Various forms of meditation also developed in Taoist China and Buddhist Indian and Nepal around fifth/sixth centuries BCE.</p>
<p>However, I am sure this simple practice will have been much more ancient than this in my opinion with individuals including High priestesses, Druids, Medicine Women, Native American Indian Truth Keepers, Dream Weaver Aboriginals, Vedic and those from the Middle East. All these people would have communed with the living spirit within themselves and with animals, nature and etheric spirits besides the living consciousness of Mother/Father God or Great Spirit. I believe meditation would have begun when the first human began to contemplate survival and their place in the world.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?67af6602